import React from 'react'
import Sidebar from './Components/Sidebae/Sidebar';
import Main from './Components/Main/Main';

export default function App() {
  return (
    <>
    
    <Sidebar/>
    <Main/>
    
    </>
  )
}
